import React from "react";

const AlertModal = ({ open, title, message, onClose }) => {
    if (!open) return null;
    return (
        <div className="alert-modal-overlay" onClick={onClose}>
            <div className="alert-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="alert-modal-title">{title}</div>
                <div className="alert-modal-message">{message}</div>
                <button className="alert-modal-btn" onClick={onClose}>Aceptar</button>
            </div>
        </div>
    );
}

export default AlertModal;